<template>
    <footer id="my-footer" itemscope="itemscope" itemtype="http://schema.org/WPFooter">
        <div class="content-footer" id="footer">
            <div class="container">
                <div class="row justify-content-between">
                    <div class="col-12 col-md-7 order-first">
                        <div class="text-center text-md-left">
                            <span class="footer-icons">Made with </span>
                            <i class="fas fa-heart red-color"></i>
                            <span class="footer-icons">by</span>
                            <router-link to="/">
                                <img class="perpage-small-icon" src="img/footer/productive-gray-without-icon.svg" alt="logo">
                            </router-link>
                        </div>
                    </div>
                    <div class="col-12 col-md-5 order-last text-center text-md-right"
                         itemscope
                         itemtype="http://schema.org/Organization"
                         :class="{'direction-rtl': language === 'he', 'direction-ltr': language === 'en', 'text-right': language === 'he', 'text-left': language === 'en'}"
                    >
                        <a name="facebook" class="decoration-none d-block my-2" rel="noopener" aria-labelledby="facebook" itemprop="sameAs" href="https://www.facebook.com/productive.labs.il" title="our facebook page">
                            <span class="footer-icons">{{ $t('האם כבר ביקרת ב-') }}</span>
                            <i class="fab fa-facebook-f"></i>
                            <span class="footer-icons">  {{ $t('שלנו?') }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: 'my-footer',
        computed: {
            ...mapState('layout', {
                language: state => state.language,
            }),
        },
    }
</script>
<style lang="css" scoped>
    #footer {
        background-color: #f8f8f8;
        padding-top: 35px;
        padding-bottom: 35px;
        direction: ltr;
        text-align: left;
    }
    .footer-icons{
        color: #676767;
    }
    .red-color{
        color:red;
    }
    .perpage-small-icon{
        height: 22px;
        vertical-align: bottom;
    }
    .decoration-none{
        text-decoration: none;
    }
    .direction-ltr {
        direction: ltr !important;
    }
    .direction-rtl {
        direction: rtl !important;
    }
    .decoration-none:hover{
        text-decoration: none;
        color:#000;
    }
</style>
